/**
 * implementation of window.onbeforeunload
 */
export class beforeUnload {
    constructor(text) {
        this.text = text;
        this.add();
    }

    fn(e) {
        var confirmationMessage = this.text;
    
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
    }

    add() {
        window.addEventListener('beforeunload', this.fn);
    }
    
    remove() {
        window.removeEventListener('beforeunload', this.fn);
    }
}


// WEBPACK FOOTER //
// ./src/helper/beforeUnload.js